export default __webpack_public_path__ + "static/media/insa_bat.961dfde8.jpg";